<i18n>
{
  "en": {
    "distance": "at {distance}\u00A0km",
    "phoneNumber": "Phone number:"
  },
  "fr": {
    "distance": "à {distance}\u00A0km",
    "phoneNumber": "Téléphone\u00A0:"
  },
  "de": {
    "distance": "{distance}\u00A0km entfernt",
    "phoneNumber": "Telefonnummer:"
  }
}
</i18n>

<template>
  <div class="store-locator-store-card">
    <div class="store-locator-store-card__header">
      <h3 class="store-locator-store-card__name">{{ store.name }}</h3>
      <span v-if="distance" class="store-locator-store-card__distance">{{
        distance
      }}</span>
    </div>
    <div class="store-locator-store-card__address" v-html="store.address"></div>
    <div class="store-locator-store-card__phone-number">
      {{ $t('phoneNumber') }}
      <a
        :href="`tel:${store.phoneNumber}`"
        class="store-locator-store-card__phone-number-link"
        >{{ store.phoneNumber }}</a
      >
    </div>
  </div>
</template>

<script>
import { haversineDistance } from '../utils/Geolocation';

export default {
  name: 'StoreLocatorStoreCard',
  props: {
    position: {
      type: Object,
      default: null,
    },
    store: {
      type: Object,
      required: true,
    },
  },
  computed: {
    /**
     * @return {string|null}
     */
    distance() {
      if (this.position) {
        const value = haversineDistance(
          [this.position.latitude, this.position.longitude],
          [this.store.latitude, this.store.longitude]
        );

        return this.$t('distance', {
          distance: new Intl.NumberFormat(document.documentElement.lang, {
            maximumFractionDigits: 1,
          }).format(value),
        });
      }

      return null;
    },
  },
};
</script>
